import { Component, h, Prop, Element, State, Event, EventEmitter, Listen, Watch, Env } from "@stencil/core"
import showdown from "showdown"
import hljs from "highlight.js"
// import { io } from "socket.io-client"
import { getComponentByControlType, splitContent, getAudioContent, getMetaInfo, getBroswerLang, getAllLanguagesInSurvey } from "../../../utils/utils"
// import mustache from "mustache"
import Handlebars from "handlebars"
import { SocketService } from "../../../utils/socket-service"
declare const google: any

@Component({
  tag: "ai12z-chat",
  styleUrls: ["ai12z-chat.css", "../../../global/tailwind.min.css", "../../../global/survey.min.css"],
  shadow: true,
  // scoped: true
})
export class MyChat {
  private cdnPath: string = "https://cdn.ai12z.net/assets/bot"
  // private socketService: SocketService

  @Element() private element: HTMLElement
  @Prop() chatId: string
  @Prop({ mutable: true }) chats: any = []
  @Prop({ mutable: true }) query: string
  @Prop() apiKey: string
  @Prop() aiMessageId: string
  @Prop({ mutable: true }) imgFiles: any
  @Prop({ mutable: true }) env: string
  @Prop({ mutable: true }) conversationId: string
  @Prop() dataAttributes: any
  @Prop() chatExcludeTags: Array<string> = []
  @Prop() chatIncludeTags: Array<string> = []
  // @Prop() socket: any
  @Prop() target: string
  @Prop() voiceType: string
  @Prop() voice: string
  @Prop() componentType: string = "search"
  @Prop() chatPosition: string = "below"
  @Prop() socketIn: SocketService
  @Prop() customstyle: string
  @Prop() customJS: string

  @State() scrollBottom: any
  @State() copied: boolean = false
  @State() isPlayed: boolean = false
  @State() buttons: Array<{ id: string; label: string }> = []
  @State() itemList: any
  @State() currentChatData: any
  @State() currentTemplate: any
  @State() currentPage: number = 0
  @State() currentResponse: any
  @State() currentSlide: number = 0
  @State() scriptArray = []

  @Event() feedback: EventEmitter
  @Event() survey: EventEmitter
  @Event() stateChanged: EventEmitter
  @Event({
    eventName: "formComplete",
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  formSubmitted!: EventEmitter<any>
  // private scripts = [`https://unpkg.com/survey-core/themes/plain-light-panelless.min.js`]
  private styles = [
    `${this.cdnPath}/v1/survey.min.css`,
    // `https://unpkg.com/survey-core/defaultV2.min.css`,
    `${this.cdnPath}/v1/survey-core.min.css`,
    `https://unpkg.com/@highlightjs/cdn-assets@11.9.0/styles/default.min.css`,
  ]
  private audioElement: HTMLAudioElement

  componentDidLoad() {
    // Load jQuery first
    // console.log("componentDidLoad chat.tsx")
    const jQueryScript = document.createElement("script")
    jQueryScript.src = this.cdnPath + "/v1/jquery.min.js" // Path relative to the www root
    jQueryScript.onload = () => {
      // console.log("jQuery loaded")
      // Load the script that loads and exposes SurveyJS
      const loadSurveyScript = document.createElement("script")
      loadSurveyScript.src = this.cdnPath + "/v1/survey.jquery.min.js" // Path relative to the www root
      loadSurveyScript.onload = () => {
        // console.log("SurveyJS loaded and SurveyModel exposed")
      }
      loadSurveyScript.onerror = err => {
        console.error("Failed to load SurveyJS:", err)
      }
      document.head.appendChild(loadSurveyScript)
      this.element.shadowRoot.appendChild(loadSurveyScript)
    }
    jQueryScript.onerror = err => {
      console.error("Failed to load jQuery:", err)
    }
    document.head.appendChild(jQueryScript)
    this.element.shadowRoot.appendChild(jQueryScript)

    // const link2 = document.createElement("link")
    // link2.rel = "stylesheet"
    // link2.href = "https://unpkg.com/@highlightjs/cdn-assets@11.9.0/styles/default.min.css"
    // this.element.shadowRoot.appendChild(link2)

    const ai12zHeading = document.createElement("script")
    ai12zHeading.text = `
      var ai12zChat = window["ai12z"] = {}
    `
    document.head.appendChild(ai12zHeading)
    this.element.shadowRoot.appendChild(ai12zHeading)

    setTimeout(() => {
      console.log("componentDidLoad chat.tsx", this.customstyle)
      console.log("customstyle", this.customJS)
      if (this.customstyle) {
        const linkEl = document.createElement("link")
        linkEl.setAttribute("rel", "stylesheet")
        linkEl.setAttribute("href", this.customstyle)
        this.element.shadowRoot?.appendChild(linkEl)
      }
      if (this.customJS) {
        const scriptEl = document.createElement("script")
        scriptEl.setAttribute("type", "text/javascript")
        scriptEl.setAttribute("src", this.customJS)
        this.element.shadowRoot?.appendChild(scriptEl)
      }
    }, 500)
    this.loadStyles()
  }

  loadStyles() {
    for (const style of this.styles) {
      const loadStyle = document.createElement("link")
      loadStyle.rel = "stylesheet"
      loadStyle.href = style
      loadStyle.onerror = err => {
        console.error("Failed to load style:", err)
      }
      this.element.shadowRoot.appendChild(loadStyle)
    }
  }

  private scrollToLatestBubble() {
    const chatContainer = this.element.shadowRoot.querySelector(".chat-list")
    const userBubbles = chatContainer?.querySelectorAll(".non-pending-user")
    const lastBubble = userBubbles?.[userBubbles.length - 1]
    // const lastBubble = chatContainer?.querySelector(`#${this.aiMessageId}`)
    if (lastBubble) {
      lastBubble.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }
  componentWillLoad() {
    this.loadStyles()
    // console.log("tags", this.chatExcludeTags, this.chatIncludeTags)
    // this.loadScripts()
    setTimeout(() => {
      if (this.socketIn && (this.query?.trim().length > 0 || this.imgFiles?.length > 0)) {
        this.invokeSocket()
      }
    }, 500)
  }

  componentDidUpdate() {
    // console.log("componentDidUpdate chat.tsx")

    // this.scrollToBottom()
    this.highlightcode()
  }

  disconnectedCallback() {
    window["ai12z"] = {}
    this.chats = []
  }

  @Watch("chats")
  watchHandler(_newValue: any, _oldValue: any) {
    // console.log("The new value of chats is: ", _newValue)
    // this.scrollToBottom()
    // this.scrollToLatestBubble()
  }
  @Listen("streamResponse", { target: "window" })
  streamResponseHandler(event: CustomEvent) {
    // console.log("streamRenderHandler", event)
    this.handleMessage(event.detail.data, this.aiMessageId)
  }

  @Listen("endResponse", { target: "window" })
  endResponseHandler(event: CustomEvent) {
    // console.log("listening end_response", event)
    this.scrollToLatestBubble()
    const data = event.detail

    const converter = new showdown.Converter()
    let finalHtml = converter.makeHtml(data.answer)
    const idx = this.chats.findIndex(item => item.id === this.aiMessageId)

    const chatId = this.chats[idx].id
    // this.chats[idx].insightId = data.insight_id
    this.chats = this.chats.map((item, i) => (i === idx ? { ...item, insightId: data.insightId } : item))
    // console.log("chats", this.chats[idx])
    if (finalHtml.indexOf("[control") > -1) {
      switch (data.controlType) {
        case "template":
          const newTemplateContent = splitContent(data.answer)
          const templateData = this.getUpdatedChat(data, "")

          this.survey.emit({ results: templateData, type: "carousel" })

          this.element.shadowRoot.querySelector(`#${this.aiMessageId}`).innerHTML = newTemplateContent?.before
          this.processTemplateData(templateData, data, "carousel")
          if (newTemplateContent.after.trim().length > 0) {
            const afterChatEle = this.getUpdatedChat(data, newTemplateContent?.after)

            this.survey.emit({ results: afterChatEle, type: "carousel" })

            this.waitForElementRender(`#${afterChatEle.id}`).then(() => {
              // console.log("Element rendered")
              if (afterChatEle.id) {
                const bubbleEle = this.element.shadowRoot.querySelector(`#${afterChatEle.id}`)
                if (bubbleEle) {
                  ;(bubbleEle.querySelector("#spinner") as HTMLElement).style.display = "none"
                }
              }
            })
          }

          break
        case "form":
          finalHtml = finalHtml.replace(RegExp(/\[[^>]*]/gm), `<div id=surveyContainer-${chatId}></div>`)
          this.element.shadowRoot.querySelector(`#${this.aiMessageId}`).innerHTML = finalHtml
          this.element.shadowRoot.querySelector(`#${this.aiMessageId}`)["style"].width = "100%"
          const surveyContainer = this.element.shadowRoot.querySelector(`#${this.aiMessageId}`)
          if (surveyContainer) {
            surveyContainer.parentElement["style"].width = "100%"
          }
          this.chats[idx].formModel = data.controlData?.data?.source ?? data.controlData
          this.invokeSurvey(this.chats[idx], data)
          break
        case "carousel":
        case "list":
          const newContent = splitContent(finalHtml)
          const chatData = this.getUpdatedChat(data, "")

          this.survey.emit({ results: chatData, type: "carousel" })

          this.element.shadowRoot.querySelector(`#${this.aiMessageId}`).innerHTML = newContent?.before
          // if (data.controlData?.data.source.carousel?.type === "slider" || data.controlData?.data.source.carousel?.type === "list") {
          data.messageId = chatData.id
          if (data.controlData?.data?.source) {
            data.controlData.data.source.customCss = this.customstyle || ""
            data.controlData.data.source.customJs = this.customJS || ""
          }
          const controlElement = getComponentByControlType(data, "ai")
          this.processChatData(chatData, controlElement)
          // } else {
          // this.processTemplateData(chatData, data, "carousel")
          // }
          if (newContent.after.trim().length > 0) {
            const afterChatEle = this.getUpdatedChat(data, newContent?.after)
            this.survey.emit({ results: afterChatEle, type: "carousel" })

            this.waitForElementRender(`#${afterChatEle.id}`).then(() => {
              if (afterChatEle.id) {
                const bubbleEle = this.element.shadowRoot.querySelector(`#${afterChatEle.id}`)
                if (bubbleEle) {
                  ;(bubbleEle.querySelector("#spinner") as HTMLElement).style.display = "none"
                }
              }
            })
          }
          break
      }
    } else {
      finalHtml = this.updateAnchorTags(finalHtml)
      finalHtml = this.updateButtonEvents(finalHtml)
      this.element.shadowRoot.querySelector(`#${this.aiMessageId}`).innerHTML = finalHtml
      this.addEventListeners(`#${this.aiMessageId}`)
    }

    this.stateChanged.emit({ state: "end_response" })

    this.conversationId = data.conversationId
    if (data.controlType === null) {
      this.chats[idx].clipboard = finalHtml
      // this.chats[this.chats.length - 1].message = finalHtml
    }
    // this.scrollToBottom()
  }

  @Listen("buttonClick")
  buttonClickHandler(event: CustomEvent) {
    // this.query = event.detail
    this.survey.emit({ results: event.detail, type: "button" })
    // this.handleButtonClick(event.detail)
  }

  private get mainObject(): any {
    if (!window["ai12z"]) {
      window["ai12z"] = {}
    }
    return window["ai12z"]
  }

  resolveLocalized(value: any, fallback: string = ""): string {
    if (!value) return fallback

    if (typeof value === "string") {
      return value
    }

    if (typeof value === "object") {
      return value[getBroswerLang()] || value.default || fallback
    }

    return fallback
  }

  alertResults = sender => {
    console.log("alertResults", sender.keyName)
    const results = JSON.parse(JSON.stringify(sender.data))
    results.description = this.resolveLocalized(sender.jsonObj.description, "")

    const submitRes = {
      results: results,
      type: "survey",
      domId: sender.implementor.renderedElement.id,
      conversationId: this.conversationId,
      completeText: this.resolveLocalized(sender.jsonObj.completeText, "Submit"),
      keyName: sender.keyName,
    }

    const surveyDom = this.element.shadowRoot.querySelector(`#${submitRes.domId}`)

    surveyDom.parentElement.innerHTML = this.resolveLocalized(sender.jsonObj.completedHtml, "<p>Thank you!</p>")
    this.formSubmitted.emit(sender)
    // sender.implementor.renderedElement.innerHTML = `<p><b>Thank you</b></p>`
    this.survey.emit(submitRes)
  }
  invokeSurvey = (chat, surveyData) => {
    // console.log("invokeSurvey", surveyData)
    if (chat.type === "user" || chat.formModel === "") return

    window["Survey"].Serializer.addProperty("survey", {
      name: "keyName:string",
      visible: false, // makes it appear in Survey Creator
      category: "general", // optional, groups the property
      default: "", // optional default value
    })
    if (typeof chat.formModel === "object") {
      chat.formModel.keyName = surveyData.keyName
    } else {
      chat.formModel = JSON.parse(chat.formModel)
      chat.formModel.keyName = surveyData.keyName
    }

    let supportedLocales
    if (chat.formModel) {
      supportedLocales = getAllLanguagesInSurvey(chat.formModel)
    }
    // console.log("supportedLocales", supportedLocales)
    if (supportedLocales.has(getBroswerLang())) {
      window["Survey"].surveyLocalization.currentLocale = getBroswerLang()
    } else {
      window["Survey"].surveyLocalization.currentLocale = "default"
    }
    const survey = new window["Survey"].Model(chat.formModel)
    const domELe = this.element.shadowRoot.querySelector(`#surveyContainer-${chat.id}`)
    window["jQuery"](domELe).Survey({ model: survey })
    // console.log("chat.formModel", typeof chat.formModel)
    if (typeof chat.formModel === "object") {
      this.hideCompleteButton(chat.formModel, survey)
    } else {
      this.hideCompleteButton(JSON.parse(chat.formModel), survey)
    }
    survey.showCompletedPage = false
    if (surveyData.theme) {
      survey.applyTheme(JSON.parse(surveyData.theme))
    }
    console.log("survey", JSON.parse(surveyData.theme))
    survey.onAfterRenderQuestionInput.add(function (_, options) {
      options.htmlElement.name = options.question.name
    })

    survey.onComplete.add(this.alertResults)
  }
  hideCompleteButton(form: any, survey) {
    survey.completeText = this.resolveLocalized(form?.completeText, "Submit")
    survey.completeHtml = this.resolveLocalized(form?.completeHtml, "Thank You!")
    if (form && form.pages) {
      form.pages.forEach((page: any) => {
        if (page.elements) {
          // console.log("page.elements", page.elements)
          page.elements.forEach((element: any) => {
            if (element.type === "html") {
              if (typeof element.html === "string") {
                if (element.html?.includes("<iframe")) {
                  survey.showCompleteButton = false
                }
              } else if (typeof element.html === "object") {
                if (element.html[getBroswerLang()]?.includes("<iframe")) {
                  survey.showCompleteButton = false
                }
              }
            }
          })
        }
      })
    }
  }
  generateUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }

  getUpdatedChat = (data, message) => {
    const newaiMessageId = `ai-message-${this.generateUUID()}`
    const newthumbsId = this.generateUUID()
    let chatEle = {
      message: message,
      type: "ai",
      status: "success",
      insightId: data.insightId,
      id: newaiMessageId,
      thumbsId: newthumbsId,
      controlType: data.controlData?.data?.source?.carousel?.type ?? "",
      // formModel: response?.formModel,
    }
    return chatEle
  }

  async processChatData(chatData, controlElement) {
    // Step 3: Append the control element if both it and the target container exist

    await this.waitForElementRender(`#${chatData.id}`).then(async () => {
      // console.log("Element rendered")
      this.hideSpinner(chatData)
      const targetContainer = this.element.shadowRoot.querySelector(`#${chatData.id}`)
      if (targetContainer && controlElement) {
        targetContainer.appendChild(controlElement)
        // console.log("targetContainer", targetContainer.parentElement)

        targetContainer.parentElement["style"].width = chatData.controlType === "slider" ? "90%" : this.componentType === "inline" ? "" : "100%"

        if (chatData.controlType === "custom" || chatData.controlType === "list" || chatData.controlType === "slider") {
          targetContainer.classList.remove("p-4")
          targetContainer.classList.add("p-0")
          targetContainer.classList.add("md:p-4")
        }
        // targetContainer["style"].width = "90%"
        await this.waitForElementToAdd(targetContainer as HTMLElement)
        // Step 5: Retrieve the content and emit the updated data
        chatData.message = targetContainer.innerHTML
        this.survey.emit({ results: chatData, type: "update" })
      }
    })
  }

  addEventforReadMore() {
    // Add event listeners to the "Read More" buttons
    this.element.shadowRoot.querySelectorAll(".read-more").forEach(button => {
      button.addEventListener("click", event => {
        const index = (event.target as HTMLElement).getAttribute("data-index") // Get index from data-index attribute
        const card = (event.target as HTMLElement).closest(".card")
        const shortDescription = card.querySelector(".short-description")
        const longDescription = card.querySelector(".long-description")
        const cardImage = card.querySelector(".card-image")

        // Toggle visibility of descriptions
        shortDescription.classList.toggle("hidden")
        longDescription.classList.toggle("hidden")

        // Update button text
        if (shortDescription.classList.contains("hidden")) {
          cardImage.classList.add("hidden")
          card.classList.remove("md:grid-cols-2")
          ;(event.target as HTMLElement).textContent = "Show Less"
        } else {
          cardImage.classList.remove("hidden")
          card.classList.add("md:grid-cols-2")
          ;(event.target as HTMLElement).textContent = "Read More"
        }

        // Optionally, you can use the index to log or perform other actions
        console.log(`Button clicked for card at index: ${index}`)
      })
    })
  }

  handlePrev = () => {
    this.currentSlide = (this.currentSlide - 1 + this.itemList.length) % this.itemList.length
    this.processTemplateData(this.currentChatData, "", "pagination")
  }

  handleNext = () => {
    this.currentSlide = (this.currentSlide + 1) % this.itemList.length
    this.processTemplateData(this.currentChatData, "", "pagination")
  }

  addEventforPanel(_template, _query) {
    this.element.shadowRoot.querySelectorAll(".panel-button").forEach(button => {
      button.addEventListener("click", event => {
        const id = (event.target as HTMLElement).getAttribute("data-id") // Get custom data-id attribute
        console.log(`Button clicked for item with ID: ${id}`)

        // Add your logic here
        const type = (event.target as HTMLElement).getAttribute("data-type") // Get custom data-id attribute
        console.log(`Button clicked for item with ID: ${type}`)
        // Add your logic here
        if (type === "panel") {
          this.processTemplateData(this.currentChatData, "", "pagination")
          // const panelTemplate = Handlebars.compile(template[Number(id) + 2].content)
          // const cardList = this.element.shadowRoot.querySelectorAll(".carousel-card")
          // const card = (event.target as HTMLElement).closest(".carousel-card")
          // const cardIndex = card.getAttribute("data-index")
          // cardList[cardIndex].innerHTML = panelTemplate({
          //   title: query.items[cardIndex].title,
          //   description: query.items[cardIndex].description,
          //   shortDescription: query.items[cardIndex].shortDescription,
          //   images: query.items[cardIndex].images,
          //   subtitle: query.items[cardIndex].subtitle,
          //   buttons: query.items[cardIndex].buttons,
          // })
          // this.addEventforcardButton(query, template)
          // this.addEventforReadMore()
        }
      })
    })
  }

  handleIndicatorClick(index: number) {
    this.currentSlide = index
    this.processTemplateData(this.currentChatData, "", "pagination")
  }

  updateCarousel() {
    const prevButton = this.element.shadowRoot.querySelector(".prev") ?? this.element.shadowRoot.querySelector(".prev-btn")
    const nextButton = this.element.shadowRoot.querySelector(".next") ?? this.element.shadowRoot.querySelector(".next-btn")

    // Attach event listeners to indicators
    const indicators = this.element.shadowRoot.querySelectorAll(".indicator")
    indicators.forEach((indicator, index) => {
      indicator.addEventListener("click", () => this.handleIndicatorClick(index))
    })

    prevButton?.addEventListener("click", this.handlePrev)

    nextButton?.addEventListener("click", this.handleNext)
  }

  renderPagination(templateType) {
    let itemsPerPage, start, end, paginatedItems, context
    switch (templateType) {
      case "carousel":
        itemsPerPage = 1
        paginatedItems = this.itemList
        const transformValue = `-${this.currentSlide * 100}%`

        context = {
          paginatedItems,
          isFirstSlide: this.currentSlide === 0,
          isLastSlide: this.currentSlide === this.itemList.length - 1,
          transform: transformValue,
          currentSlide: this.currentSlide,
        }

        return { context: context, end: end }

      case "list":
        itemsPerPage = 5
        start = this.currentPage * itemsPerPage
        end = start + itemsPerPage
        paginatedItems = this.itemList.slice(start, end)

        context = {
          items: paginatedItems,
          hasPrev: this.currentPage > 0,
          hasNext: end < this.itemList.length,
        }

        return { context: context, end: end }
    }
  }

  addEventforPagination(end) {
    // Add event listeners for buttons
    this.element.shadowRoot.querySelector(".prev-btn")?.addEventListener("click", () => {
      if (this.currentPage > 0) {
        this.currentPage--
        this.processTemplateData(this.currentChatData, "", "pagination")
      }
    })

    this.element.shadowRoot.querySelector(".next-btn")?.addEventListener("click", () => {
      if (end < this.itemList.length) {
        this.currentPage++
        this.processTemplateData(this.currentChatData, "", "pagination")
      }
    })
  }

  addEventforcardButton(query, template) {
    // Attach event listeners
    this.element.shadowRoot.querySelectorAll(".card-button").forEach(button => {
      button.addEventListener("click", event => {
        // Register a Handlebars helper to stringify objects
        Handlebars.registerHelper("json", function (context) {
          return JSON.stringify(context)
        })
        const id = (event.target as HTMLElement).getAttribute("data-id") // Get custom data-id attribute
        console.log(`Button clicked for item with ID: ${id}`)

        // Add your logic here
        const type = (event.target as HTMLElement).getAttribute("data-type") // Get custom data-id attribute
        console.log(`Button clicked for item with ID: ${type}`)

        const url = (event.target as HTMLElement).getAttribute("data-url")
        console.log(`Button clicked for item with ID: ${url}`)
        // Add your logic here
        if (type === "panel") {
          const panelTemplate = Handlebars.compile(template[Number(id) + 1].content)
          const cardList = this.element.shadowRoot.querySelectorAll(".carousel-card")
          const card = (event.target as HTMLElement).closest(".carousel-card")
          const cardIndex = card.getAttribute("data-index")
          cardList[cardIndex].innerHTML = panelTemplate({
            form: query.items[cardIndex].panels[Number(id)]?.form,
            formSettings: query.formSettings,
            buttons: query.items[cardIndex].panels[Number(id)]?.buttons,
          })
          this.addEventforPanel(template, query)
        }
        if (type === "url") {
          window.open(url, "_blank")
        }
      })
    })
  }

  async processTemplateData(chatData, data, _inputType) {
    this.currentChatData = chatData
    await this.waitForElementRender(`#${chatData.id}`).then(async () => {
      this.hideSpinner(chatData)
      const targetContainer = this.element.shadowRoot.querySelector(`#${chatData.id}`)
      // console.log("targetContainer", targetContainer.parentElement)

      let handletemplate
      if (targetContainer) {
        if (_inputType === "carousel") {
          this.currentTemplate = data.controlData?.template
          this.currentResponse = data.controlData?.data.source
          this.itemList = this.currentResponse.items
        }

        targetContainer.parentElement["style"].width = "90%"

        handletemplate = Handlebars.compile(this.currentTemplate[0]?.content)
        // targetContainer["dangerouslySetInnerHTML"] = { __html: handletemplate(this.renderPagination().context, { currentSlide: this.currentSlide }) }
        if (this.currentResponse.process === "list") {
          targetContainer.innerHTML = handletemplate(this.renderPagination("list").context)
          this.addEventforPagination(this.renderPagination("list").end)
        } else if (this.currentResponse.process === "carousel") {
          // Register the custom 'eq' helper for Handlebars
          Handlebars.registerHelper("eq", function (a, b) {
            return a === b
          })
          targetContainer.innerHTML = handletemplate(this.renderPagination("carousel").context)
          this.updateCarousel()
        } else {
          // Register the helper
          Handlebars.registerHelper("processArray", function (array) {
            if (!Array.isArray(array)) {
              return "" // Return an empty string if the input is not an array
            }
            return new Handlebars.SafeString(JSON.stringify(array))
          })
          chatData.data = data.controlData.data

          if (data.controlData && data.controlData.data) {
            data.controlData.data.msgId = chatData.id //`msg-${chatData.id}`
          }
          targetContainer.innerHTML = handletemplate({ msgId: `${chatData.id}`, source: this.currentResponse, llm: data.controlData.data.llm })
          // targetContainer.innerHTML = handletemplate({ chartId: `chart-${chatData.id}`, source: new Handlebars.SafeString(JSON.stringify(this.currentResponse)) })
          setTimeout(() => {
            this.renderTemplateData(chatData)
          }, 1000)
        }

        // targetContainer["style"].width = "100%"
        // targetContainer.innerHTML = handletemplate({ localData: new Handlebars.SafeString(JSON.stringify(query)) })
        // finalHtml = mustache.render(template, { chartData: query })
        // this.element.shadowRoot.querySelector(`#${this.aiMessageId}`).innerHTML = finalHtml

        this.addEventforReadMore()
        this.addEventforcardButton(this.currentResponse, this.currentTemplate)
        chatData.message = targetContainer.innerHTML
        this.survey.emit({ results: chatData, type: "update" })
      }
    })
  }

  renderTemplateData(chatData) {
    // console.log(`#${chatData.id}`)

    if (!this.mainObject[`${chatData.id}`]) {
      this.mainObject[`${chatData.id}`] = {}
    }
    const scripts = this.element.shadowRoot.querySelectorAll(`#${chatData.id} script`)
    scripts.forEach(script => {
      const newScript = document.createElement("script")
      newScript.type = "text/javascript"

      // If it's an external script (with `src`), copy the `src` attribute
      if ((script as HTMLScriptElement).src) {
        newScript.src = (script as HTMLScriptElement).src
      } else {
        // If it's inline, set the JavaScript code as the content of the new <script> element
        // newScript.innerHTML = `const source = ${JSON.stringify(chatData.data.source)};\n`
        // newScript.innerHTML += `const llm = ${JSON.stringify(chatData.data.llm)};\n`
        newScript.innerHTML += script.innerHTML
      }
      // Append the new script to the document body to execute it
      if (!newScript.src) {
        this.scriptArray.push(newScript)
      }
      script.parentNode?.removeChild(script)

      // Optionally, remove the old <script> tag from the DOM

      if (newScript.src && !this.element.shadowRoot.querySelector(`script[src="${newScript.src}"]`)) {
        this.element.shadowRoot.appendChild(newScript)
      } else {
        const scriptDom = this.element.shadowRoot.querySelector(`script[type="text/javascript"]`)
        if (scriptDom && !newScript.src) {
          if (this.scriptArray.length > 1) {
            this.scriptArray.forEach(script => {
              if (!script.src && script.innerHTML !== newScript.innerHTML) {
                this.element.shadowRoot.appendChild(newScript)
              }
            })
          } else {
            this.element.shadowRoot.appendChild(newScript)
          }
          // this.element.shadowRoot.appendChild(newScript)
        }
      }
    })
    // Step 4: Ensure Google Charts is loaded, then call the `drawGoogleChart` function
    setTimeout(() => {
      this.initializeScript(chatData.id)
    }, 1000)
  }

  initializeScript(id) {
    if (typeof this.mainObject[`${id}`]["onLoadCallback"] === "function") {
      this.mainObject[`${id}`]["onLoadCallback"]()
    }
    // window["google"]?.charts.load("current", { packages: ["corechart"] })
    // window["google"]?.charts.setOnLoadCallback()
  }

  hideSpinner(chatData) {
    // Logic for hiding the spinner (assumed to return a Promise if async is needed)
    return new Promise(resolve => {
      const renderedBubble = this.element.shadowRoot.querySelector(`#${chatData.id}`)
      if (renderedBubble && renderedBubble.querySelector("#spinner")) {
        ;(renderedBubble.querySelector("#spinner") as HTMLElement).style.display = "none"
      }
      // Assume some async action here, then resolve
      // console.log("Spinner hidden")
      resolve(true)
    })
  }

  waitForElementRender(selector: string) {
    return new Promise<void>(resolve => {
      // Check if the target element is already in the DOM
      if (this.element.shadowRoot.querySelector(selector)) {
        resolve() // Resolve immediately if the element is already present
        return
      }

      const observer = new MutationObserver(() => {
        // Check for the target element in each mutation
        const targetElement = this.element.shadowRoot.querySelector(selector)
        if (targetElement) {
          // console.log("Element found:", targetElement)
          resolve() // Resolve the promise once the element is found
          observer.disconnect() // Stop observing after the element is found
        }
      })

      // Observe childList changes within the parent element and its subtree
      observer.observe(this.element.shadowRoot, { childList: true, subtree: true })
    })
  }

  // Helper function to detect when the target element is rendered
  waitForElementToAdd(element: HTMLElement) {
    return new Promise<void>(resolve => {
      const observer = new MutationObserver(_mutations => {
        resolve()
        observer.disconnect()
      })
      observer.observe(element, { childList: true, subtree: true })
    })
  }

  invokeSocket() {
    const socketId = this.socketIn.getSocketId()

    if (socketId) {
      const retrievedService = SocketService.getInstanceById(socketId)
      const socket = retrievedService.getSocket()
      const data = {
        apiKey: this.apiKey ?? Env.DATA_KEY,
        query: this.query,
        conversationId: this.conversationId ?? "",
        base64Images: this.imgFiles?.length > 0 ? this.imgFiles : [],
        event: "evaluate_query",
        attributes: this.dataAttributes,
        excludeTags: this.chatExcludeTags,
        includeTags: this.chatIncludeTags,
        meta: getMetaInfo(),
      }

      socket.emit("evaluate_query", data)
      this.scrollToLatestBubble()
    }
  }

  updateAnchorTags(htmlContent: string) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(htmlContent, "text/html")
    const anchorTags = Array.from(doc.querySelectorAll("a"))

    anchorTags.forEach(anchor => {
      // console.log("targtet", this.target)
      anchor.setAttribute("target", this.target)
      anchor.classList.add("ai12z-cta-link")
    })

    // Update the htmlContent with the modified anchor tags
    return doc.body.innerHTML
  }
  updateButtonEvents(htmlContent: string) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(htmlContent, "text/html")
    const buttons = Array.from(doc.querySelectorAll("button"))

    this.buttons = buttons.map((button, index) => {
      const id = button.id || `button-${index}`
      const label = button.textContent || `Button ${index + 1}`
      button.id = id
      button.setAttribute("data-original-click", button.getAttribute("onclick") || "")
      button.removeAttribute("onclick")
      button.classList.add("active")
      return {
        id,
        label,
        onClick: () => alert(`Button ${id} clicked!`),
      }
    })

    // Update the htmlContent with the modified buttons
    return doc.body.innerHTML
  }

  addEventListeners(msgId) {
    const container = this.element.shadowRoot.querySelector(msgId)
    if (container) {
      this.buttons.forEach(button => {
        const buttonElement = container.querySelector(`#${button.id}`)
        // console.log("buttonElement", buttonElement)
        // if (buttonElement) {
        //   buttonElement.addEventListener("click", this.handleButtonClick(button.label))
        // }
        if (buttonElement) {
          const originalCall = buttonElement.getAttribute("data-original-click") // Ensure type safety or handle undefined
          if (!originalCall) {
            console.warn(`originalClickHandler is not defined for button with id: ${button.id}`)
            return
          }

          // const match = originalCall.match(/^(\w+)\s*\((.*)\)$/) // extract name and arguments
          const match = originalCall.match(/^(\w+)\s*\(([\s\S]*)\)$/)
          // console.log("match", match)
          if (match) {
            const funcName = match[1]
            const argsStr = match[2] // string of args, like "'param', true"
            // const self = this
            // const func = self[funcName]
            buttonElement.addEventListener("click", () => {
              // if (typeof this[funcName] === "function") {
              try {
                // console.log("args", argsStr)
                // Evaluate arguments safely
                switch (funcName) {
                  case "sendQuery":
                    console.warn("sendQuery is deprecated, use sendMessage instead")

                    this.survey.emit({ results: button.label, type: "button" })
                    break
                  case "sendMessage":
                    const msgArgs = eval(`[${argsStr}]`)
                    this.survey.emit({ results: msgArgs, type: "sendMessage" })
                    // func.apply(self, msgArgs)
                    break

                  case "sendJSON":
                    const tempArgs = argsStr.match(/^'(.*?)'\s*,\s*'(.*?)'$/)

                    const rawObjectStr = tempArgs[1]
                      .replace(/([{,])\s*(\w+)\s*:/g, '$1"$2":') // quote keys
                      .replace(/:\s*'([^']*)'/g, ': "$1"') // convert single to double quotes

                    const parsedObj = JSON.parse(rawObjectStr)
                    const jsonArgs = [parsedObj, tempArgs[2]]
                    // func.apply(self, jsonArgs)
                    this.survey.emit({ results: jsonArgs, type: "sendJSON" })
                    break
                }
              } catch (err) {
                console.error(`Error invoking ${funcName}:`, err)
              }
            })
            // buttonElement.addEventListener("click", this.handleButtonClick(button.label))
          }
        }
      })
    }
  }

  handleButtonClick = (label: string) => (_event: Event) => {
    // console.log(`${label} clicked! ${event}`)
    // buttonEle.classList.add("active")
    this.survey.emit({ results: label, type: "button" })
  }

  handleMessage = (data, aiMessageId) => {
    const converter = new showdown.Converter()
    const aiMessageBubble = this.element.shadowRoot.querySelector(`#${aiMessageId}`)

    if (!aiMessageBubble) {
      console.error(`Message bubble with ID ${aiMessageId} not found.`)
      return
    }
    var bubbleText = aiMessageBubble.getAttribute("data-bubbleText") || ""
    bubbleText = bubbleText + data
    aiMessageBubble.setAttribute("data-bubbleText", bubbleText)

    // Assuming data is a string containing the message content
    let html = converter.makeHtml(bubbleText)
    const spinner = document.getElementById("spinner")
    if (spinner) {
      spinner.style.display = "none"
    }
    // Append new content to the existing chat bubble
    aiMessageBubble.innerHTML = html

    this.chats[this.chats.length - 1].status = "success"
  }

  @Listen("stopStream", { target: "document" })
  stopStreamInputHandler(_state) {
    if (this.socketIn) {
      // console.log("*****stop stream***", this.socketIn)
      // this.socketIn.disconnect()
      SocketService.disconnectSocketById(_state.detail.socketId)
    }
  }

  @Listen("startStream", { target: "document" })
  startStreamInputHandler(_state) {
    // console.log("*****start stream***", _state.detail?.search)
    if (_state.detail?.maxQuestion) {
      setTimeout(() => {
        this.hideSpinner(_state.detail.chatData)
        this.scrollToLatestBubble()
      }, 1000)
    } else {
      this.query = _state.detail?.search
      this.imgFiles = _state.detail?.imgFiles
      this.invokeSocket()
      setTimeout(() => {
        this.scrollToLatestBubble()
      }, 500)
    }
  }

  highlightcode() {
    hljs.configure({
      ignoreUnescapedHTML: true,
    })

    // Select <pre> elements within the shadow DOM
    const preElements = this.element.shadowRoot.querySelectorAll("pre")

    // Log the <pre> elements or perform other actions
    preElements.forEach(pre => {
      hljs.highlightElement(pre)
    })
  }

  scrollToBottom = () => {
    this.scrollBottom = this.element.shadowRoot.querySelector(".scroll-bottom")
    this.scrollBottom.scrollIntoView({ behavior: "smooth", block: "end" })
  }
  disableFeedback = (id: string): void => {
    const thumbsUp = this.element.shadowRoot.querySelector(`#thumbsUp_${id}`)
    const thumbsDown = this.element.shadowRoot.querySelector(`#thumbsDown_${id}`)
    thumbsUp.classList.add("not-allowed")
    thumbsUp.setAttribute("disabled", "true")
    thumbsDown.classList.add("not-allowed")
    thumbsDown.setAttribute("disabled", "true")
  }

  thumbsUp = (id: string, insightId: string): void => {
    const thumbsUp = this.element.shadowRoot.querySelector(`#thumbsUp_${id}`)
    thumbsUp.classList.add("thumbs-up")
    thumbsUp.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="currentColor">
        <path  d="M7.493 18.5c-.425 0-.82-.236-.975-.632A7.48 7.48 0 0 1 6 15.125c0-1.75.599-3.358 1.602-4.634.151-.192.373-.309.6-.397.473-.183.89-.514 1.212-.924a9.042 9.042 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75A.75.75 0 0 1 15 2a2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H14.23c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23h-.777ZM2.331 10.727a11.969 11.969 0 0 0-.831 4.398 12 12 0 0 0 .52 3.507C2.28 19.482 3.105 20 3.994 20H4.9c.445 0 .72-.498.523-.898a8.963 8.963 0 0 1-.924-3.977c0-1.708.476-3.305 1.302-4.666.245-.403-.028-.959-.5-.959H4.25c-.832 0-1.612.453-1.918 1.227Z" />
      </svg>
    `
    this.disableFeedback(id)
    this.feedback.emit({ insightId: insightId, feedback: { value: 1 } })
  }

  thumbsDown = (id: string, insightId: string): void => {
    const thumbsDown = this.element.shadowRoot.querySelector(`#thumbsDown_${id}`)
    thumbsDown.classList.add("thumbs-down")
    thumbsDown.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M15.73 5.5h1.035A7.465 7.465 0 0 1 18 9.625a7.465 7.465 0 0 1-1.235 4.125h-.148c-.806 0-1.534.446-2.031 1.08a9.04 9.04 0 0 1-2.861 2.4c-.723.384-1.35.956-1.653 1.715a4.499 4.499 0 0 0-.322 1.672v.633A.75.75 0 0 1 9 22a2.25 2.25 0 0 1-2.25-2.25c0-1.152.26-2.243.723-3.218.266-.558-.107-1.282-.725-1.282H3.622c-1.026 0-1.945-.694-2.054-1.715A12.137 12.137 0 0 1 1.5 12.25c0-2.848.992-5.464 2.649-7.521C4.537 4.247 5.136 4 5.754 4H9.77a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23ZM21.669 14.023c.536-1.362.831-2.845.831-4.398 0-1.22-.182-2.398-.52-3.507-.26-.85-1.084-1.368-1.973-1.368H19.1c-.445 0-.72.498-.523.898.591 1.2.924 2.55.924 3.977a8.958 8.958 0 0 1-1.302 4.666c-.245.403.028.959.5.959h1.053c.832 0 1.612-.453 1.918-1.227Z" />
      </svg>
    `
    this.disableFeedback(id)
    this.feedback.emit({ insightId: insightId, feedback: { value: -1 } })
  }

  // Function to copy the text to clipboard
  copyToClipboard(text: string) {
    navigator.clipboard
      .write([
        new ClipboardItem({
          "text/html": new Blob([text], { type: "text/html" }),
          "text/plain": new Blob([this.removeHtmlTags(text)], { type: "text/plain" }),
        }),
      ])
      .then(() => {
        // console.log("Text copied to clipboard", text)
        this.copied = true // Set a flag to show copied state
        setTimeout(() => {
          this.copied = false // Reset copied state after 2 seconds
        }, 2000)
      })
  }

  // Method to remove HTML tags from a string
  removeHtmlTags(text: string): string {
    const div = document.createElement("div")
    div.innerHTML = text
    return div.textContent || div.innerText || ""
  }

  // Function to trigger the text-to-speech
  async speakText(msg: string) {
    if (this.voiceType === "default") {
      if ("speechSynthesis" in window) {
        const voices = window.speechSynthesis.getVoices()
        const voice = voices.find(voice => voice.name === this.voice)
        this.isPlayed = true
        const utterance = new SpeechSynthesisUtterance(msg) // Create a speech synthesis utterance
        utterance.lang = "en-US" // Set the language, you can change this as needed
        utterance.rate = 1
        utterance.pitch = 1
        utterance.voice = voice
        // Speak the text
        window.speechSynthesis.speak(utterance)
      } else {
        alert("Speech Synthesis API is not supported in your browser.")
      }
    }

    if (this.voiceType === "google") {
      const base64audiocontent = await getAudioContent(this.apiKey ?? Env.DATA_KEY, this.env ?? Env.DATA_MODE, msg, this.voice)
      const audioBlob = this.base64ToBlob(base64audiocontent.audio_content, "audio/mpeg")
      const audioUrl = URL.createObjectURL(audioBlob)

      // Create the audio element
      this.audioElement = new Audio(audioUrl)
      this.audioElement.onended = () => {
        // this.isPlaying = false
        this.isPlayed = false
      }
      if (this.audioElement.paused) {
        this.audioElement.play()
        this.isPlayed = true
      } else {
        this.audioElement.pause()
        this.audioElement.currentTime = 0
        this.audioElement.src = "" // Remove the audio source
        this.audioElement = null // Dereference the object
        this.isPlayed = false
      }
    }
  }

  base64ToBlob(base64: string, mimeType: string): Blob {
    const byteCharacters = atob(base64)
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i))
    const byteArray = new Uint8Array(byteNumbers)
    return new Blob([byteArray], { type: mimeType })
  }
  render() {
    const email = ""

    return (
      <ul
        class={{
          "chat-list": true,
          "custom-list": this.componentType === "search",
          // "custom-chat-top-height": this.componentType === "search",
          "custom-chat-bottom-height": this.componentType === "inline",
          "custom-chat-above-height": this.componentType === "inline" && this.chatPosition === "above",
        }}
        style={{ maxHeight: this.componentType !== "search" ? "80vh" : "100%" }}
      >
        {this.chats?.map((chat, idx) => {
          const isBot = chat.type === "ai"
          // const showAvatar = isBot && (idx === 0 || this.chats[idx - 1].type !== "ai")
          const showAvatar = isBot && (idx === this.chats.length - 1 || this.chats[idx + 1]?.type !== "ai") // Show avatar only for the last AI response
          return (
            <li
              class={{
                "text-md": true,
                "chat-list-item": true,
                "chat-align-list": chat.type !== "user",
                "chat-not-user-list": chat.type === "user",
              }}
            >
              {chat.type !== "user" && (
                <div class="chat-inner-list">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class={`w-8 h-8  ${showAvatar ? "hidden md:block" : "opacity-0"}`}
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                    />
                  </svg>
                </div>
              )}
              {chat.status === "pending" && (
                <div class="pending-chat">
                  <svg class="animate-spin h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 0 1 4 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </div>
              )}
              <div
                id="parent-element"
                onMouseEnter={e => {
                  let popup = (e.target as HTMLElement).querySelector(".non-user-container") as HTMLElement
                  if (popup) popup.style.display = "block"
                }}
                onMouseLeave={e => {
                  let popup = (e.target as HTMLElement).querySelector(".non-user-container") as HTMLElement
                  if (popup) popup.style.display = "none"
                }}
                // style={{ width: chat.type !== "user" ? "90%" : "auto" }}
              >
                {chat.status !== "pending" && (
                  <div
                    class={{
                      "p-4": true,
                      "max-w-full": this.componentType === "search" ? true : false,
                      "prose": true,
                      "resize": chat.formModel?.hasOwnProperty("answer"),
                      "non-pending-user": true,
                      // "p-0": chat.controlType === "list" ? true : false,
                    }}
                    id={chat.id}
                    innerHTML={chat.message}
                  >
                    {chat?.images?.map(img => {
                      return <img src={img} class="thumbnail" alt="thumbnail" width="70" height="50" />
                    })}
                    {chat.type !== "user" && (
                      <svg class="animate-spin h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" id="spinner">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path
                          class="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 0 1 4 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                    )}
                  </div>
                )}
                {chat.type !== "user" && chat.clipboard && (
                  <div class="non-user-container" style={{ display: "none" }}>
                    {this.isPlayed && (
                      <button
                        class="copy-btn"
                        onClick={() => {
                          this.isPlayed = false
                          window.speechSynthesis.cancel()
                          if (this.audioElement) {
                            this.audioElement.pause()
                            this.audioElement.currentTime = 0
                            this.audioElement.src = "" // Remove the audio source
                            this.audioElement = null // Dereference the object
                          }
                          // this.isPlayed = false
                        }}
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-md-heavy">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM9.5 8.5C8.94772 8.5 8.5 8.94772 8.5 9.5V14.5C8.5 15.0523 8.94772 15.5 9.5 15.5H14.5C15.0523 15.5 15.5 15.0523 15.5 14.5V9.5C15.5 8.94772 15.0523 8.5 14.5 8.5H9.5Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    )}
                    {!this.isPlayed && (
                      <button class="copy-btn" onClick={() => this.speakText(this.removeHtmlTags(chat.clipboard))}>
                        <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11 4.9099C11 4.47485 10.4828 4.24734 10.1621 4.54132L6.67572 7.7372C6.49129 7.90626 6.25019 8.00005 6 8.00005H4C3.44772 8.00005 3 8.44776 3 9.00005V15C3 15.5523 3.44772 16 4 16H6C6.25019 16 6.49129 16.0938 6.67572 16.2629L10.1621 19.4588C10.4828 19.7527 11 19.5252 11 19.0902V4.9099ZM8.81069 3.06701C10.4142 1.59714 13 2.73463 13 4.9099V19.0902C13 21.2655 10.4142 22.403 8.81069 20.9331L5.61102 18H4C2.34315 18 1 16.6569 1 15V9.00005C1 7.34319 2.34315 6.00005 4 6.00005H5.61102L8.81069 3.06701ZM20.3166 6.35665C20.8019 6.09313 21.409 6.27296 21.6725 6.75833C22.5191 8.3176 22.9996 10.1042 22.9996 12.0001C22.9996 13.8507 22.5418 15.5974 21.7323 17.1302C21.4744 17.6185 20.8695 17.8054 20.3811 17.5475C19.8927 17.2896 19.7059 16.6846 19.9638 16.1962C20.6249 14.9444 20.9996 13.5175 20.9996 12.0001C20.9996 10.4458 20.6064 8.98627 19.9149 7.71262C19.6514 7.22726 19.8312 6.62017 20.3166 6.35665ZM15.7994 7.90049C16.241 7.5688 16.8679 7.65789 17.1995 8.09947C18.0156 9.18593 18.4996 10.5379 18.4996 12.0001C18.4996 13.3127 18.1094 14.5372 17.4385 15.5604C17.1357 16.0222 16.5158 16.1511 16.0539 15.8483C15.5921 15.5455 15.4632 14.9255 15.766 14.4637C16.2298 13.7564 16.4996 12.9113 16.4996 12.0001C16.4996 10.9859 16.1653 10.0526 15.6004 9.30063C15.2687 8.85905 15.3578 8.23218 15.7994 7.90049Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    )}
                    <button class="copy-btn" onClick={() => this.copyToClipboard(chat.clipboard)}>
                      {!this.copied && (
                        <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M7 5C7 3.34315 8.34315 2 10 2H19C20.6569 2 22 3.34315 22 5V14C22 15.6569 20.6569 17 19 17H17V19C17 20.6569 15.6569 22 14 22H5C3.34315 22 2 20.6569 2 19V10C2 8.34315 3.34315 7 5 7H7V5ZM9 7H14C15.6569 7 17 8.34315 17 10V15H19C19.5523 15 20 14.5523 20 14V5C20 4.44772 19.5523 4 19 4H10C9.44772 4 9 4.44772 9 5V7ZM5 9C4.44772 9 4 9.44772 4 10V19C4 19.5523 4.44772 20 5 20H14C14.5523 20 15 19.5523 15 19V10C15 9.44772 14.5523 9 14 9H5Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      )}
                      {this.copied && (
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M19.8198 6.19526C20.0601 6.45561 20.0601 6.87772 19.8198 7.13807L9.9736 17.8047C9.73328 18.0651 9.34364 18.0651 9.10332 17.8047L4.18024 12.4714C3.93992 12.2111 3.93992 11.7889 4.18024 11.5286C4.42056 11.2682 4.8102 11.2682 5.05053 11.5286L9.53846 16.3905L18.9495 6.19526C19.1898 5.93491 19.5794 5.93491 19.8198 6.19526Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      )}
                    </button>
                    <button id={`thumbsUp_${chat.thumbsId}`} onClick={() => this.thumbsUp(chat.thumbsId, chat.insightId)} class={"chat-thumbs-up"}>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M6.633 10.25c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282m0 0h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23H5.904m10.598-9.75H14.25M5.904 18.5c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 0 1-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 9.953 4.167 9.5 5 9.5h1.053c.472 0 .745.556.5.96a8.958 8.958 0 0 0-1.302 4.665c0 1.194.232 2.333.654 3.375Z"
                        />
                      </svg>
                    </button>

                    <button id={`thumbsDown_${chat.thumbsId}`} onClick={() => this.thumbsDown(chat.thumbsId, chat.insightId)} class={"chat-thumbs-up"}>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M7.498 15.25H4.372c-1.026 0-1.945-.694-2.054-1.715a12.137 12.137 0 0 1-.068-1.285c0-2.848.992-5.464 2.649-7.521C5.287 4.247 5.886 4 6.504 4h4.016a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23h1.294M7.498 15.25c.618 0 .991.724.725 1.282A7.471 7.471 0 0 0 7.5 19.75 2.25 2.25 0 0 0 9.75 22a.75.75 0 0 0 .75-.75v-.633c0-.573.11-1.14.322-1.672.304-.76.93-1.33 1.653-1.715a9.04 9.04 0 0 0 2.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384m-10.253 1.5H9.7m8.075-9.75c.01.05.027.1.05.148.593 1.2.925 2.55.925 3.977 0 1.487-.36 2.89-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398-.306.774-1.086 1.227-1.918 1.227h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 0 0 .303-.54"
                        />
                      </svg>
                    </button>
                    <button class="copy-btn">
                      <a
                        href={`mailto:${email}?subject=${encodeURIComponent(this.chats[idx - 1]?.message)}&body=${encodeURIComponent(this.removeHtmlTags(chat.clipboard))}`}
                        target="_blank"
                      >
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="0.3" class="w-6 h-6">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M3.75 5.25L3 6V18L3.75 18.75H20.25L21 18V6L20.25 5.25H3.75ZM4.5 7.6955V17.25H19.5V7.69525L11.9999 14.5136L4.5 7.6955ZM18.3099 6.75H5.68986L11.9999 12.4864L18.3099 6.75Z"
                            fill="currentColor"
                          ></path>{" "}
                        </svg>
                      </a>
                    </button>
                  </div>
                )}
              </div>
            </li>
          )
        })}
        <div class="scroll-bottom" />
      </ul>
    )
  }
}
